/*
* 标注相关api
* */
const markApi = {
  list: '/kbms/rule/statistics/list', // 管理看板-查询
  export: '/kbms/rule/statistics/export', // 管理看板-导出
}

export default markApi
